import React from "react";
import "./TopHeader.css";


function TopHeader() {
    return(
        <div className="container-fluid" id ="EnirisstHeader">
            <p style = {{marginTop:"2%"}}> Τα δεδομένα που χρησιμοποιήθηκαν για τη δόμηση της υπηρεσίας συλλέχθηκαν και επεξεργάστηκαν
            </p>
            <p> στο πλαίσιο της ερευνητικής υποδομής <b>E.N.I.R.I.S.S.T.</b></p>
            <p>Πηγές: Υπηρεσία Πολιτικής Αεροπορίας, ελεύθερα δεδομένα στο διαδίκτυο</p>
        </div>

    );
}

export default TopHeader;